export function registerServiceWorker (): void {
  if ('serviceWorker' in navigator) {
    try {
      navigator.serviceWorker.register(
        import.meta.env.MODE === 'production' ? '/sw.js' : '/dev-sw.js?dev-sw',
        { type: import.meta.env.MODE === 'production' ? 'classic' : 'module' },
      )
    } catch (error) {
      console.log('Service worker registration failed:', error)
    }
  }
}
